import { makeStyles } from '@material-ui/core/styles'
import { Box, Button, ButtonGroup, Card, CardActions, CardContent, Typography } from '@mui/material'
import React from 'react'
import { TooltipRenderProps } from 'react-joyride'
import ReactMarkdown from 'react-markdown'

import { IOnboardingJoyrideStep } from '../onboardingJoyride.types'

const useStyles = makeStyles({
  root: {
    minWidth: 350,
    maxWidth: 350,
    zIndex: 1300,
    position: 'absolute',
  },
})

export interface ITargetJoyrideTooltipProps extends Omit<TooltipRenderProps, 'step'> {
  step: IOnboardingJoyrideStep
}

export function TargetJoyrideTooltip({
  continuous,
  primaryProps,
  skipProps,
  step,
  closeProps,
}: ITargetJoyrideTooltipProps) {
  const classes = useStyles()
  return (
    <Card className={classes.root}>
      <CardContent>
        <ReactMarkdown
          components={{
            p: ({ children, ...props }) => (
              <Typography variant="h6" {...props}>
                {children}
              </Typography>
            ),
          }}
          className="line-break"
        >
          {step?.content ?? ''}
        </ReactMarkdown>
      </CardContent>
      <CardActions>
        <Box width="100%" display="flex" justifyContent="space-between">
          <Button {...skipProps} variant="outlined">
            {closeProps.title}
          </Button>
          <ButtonGroup>
            {continuous && (
              <Button variant="contained" color="primary" {...primaryProps}>
                {`${primaryProps.title}`}
              </Button>
            )}
          </ButtonGroup>
        </Box>
      </CardActions>
    </Card>
  )
}
